import React from 'react'
import OperationContext from '../contexts/OperationContext'

export default function useOperation () {
  return React.useContext(OperationContext)
}
